@if (hasElevatedRole()) {
    <div class="flex flex-row gap-1 items-center rounded shadow-sm text-white text-xs sm:text-sm pl-1 pr-1 pb-[2px] pt-[2px]" [style.background]="roleColor">
        <svg-icon [svgIcon]="starSvgIcon" [small]="true" class=" stroke-white fill-white"></svg-icon>
        <p>{{ roleLabel }}</p>
    </div>
}